// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2Zu5J","logoGrid":"Logo_logoGrid__3-Yol","cls1":"Logo_cls1__1ZGft","cls2":"Logo_cls2__2Nxo7","bounce":"Logo_bounce__1WMGD"};